import { PayoutBank as PayoutBankDto } from 'legacy/events/types';

function getBankByStripeId(
  banks: {
    hostBanks: PayoutBankDto[];
    associationsBanks: PayoutBankDto[];
  },
  stripeId: string
) {
  return [...banks.hostBanks, ...banks.associationsBanks].find(
    (bankItem) => bankItem.stripeId === stripeId
  );
}

export default getBankByStripeId;
